import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './base_app/components/App';
import reportWebVitals from './reportWebVitals';
import {createTheme, ThemeProvider} from "@mui/material/styles";
import styles from './style-export.module.scss';
import {Provider} from "react-redux";
import {combineReducers, createStore} from "redux";
import { settingsReducer } from "./state/reducers/settingsReducer";
import { dataReducer } from "./state/reducers/dataReducer";
import { filterReducer } from "./state/reducers/filterReducer";

// import { StyledEngineProvider } from '@mui/material/styles';

const rootReducer = combineReducers({
    settings: settingsReducer,
    data: dataReducer,
    filter: filterReducer
})

const store = createStore(rootReducer);

// A custom theme for this app
const theme = createTheme({
    palette: {
        primary: {
            main: styles.colorPrimary,
        },
        secondary: {
            main: styles.colorSecondary,
        },
        error: {
            main: styles.colorError
        },
    },
});



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();